<div class="qr-cam" (click)="onPreviewTap($event)">
  <video #video muted autoplay playsinline></video>
  <canvas #canvas hidden></canvas>
  <!-- Square reticle to aim the QR code into -->
  <div class="reticle"></div>
  <app-focus-ring [point]="focusRingPoint"></app-focus-ring>
</div>
